import { ProxyBid } from 'types';

export const getLatestProxyBid = (proxyBids?: ProxyBid[] | null) => {
  if (!proxyBids || !proxyBids?.length) {
    return undefined;
  }

  if (proxyBids.length === 1) {
    return proxyBids[0];
  }

  return proxyBids.reduce?.((prev, current) => (current.id > prev.id ? current : prev));
};
